/**
 * Request headers that carry meaning rather than transport.
 *
 * Lower case because HTTP/2 forbids anything else on the wire and both Hono and
 * API Gateway normalise to it - comparing against a capitalised literal is a bug
 * that only shows up at runtime.
 */

/**
 * Which workspace a request is about. ADR-030: the workspace is not a path
 * segment, because the endpoint tables ADR-025 adopted have no room for one.
 */
export const WORKSPACE_HEADER = 'x-workspace-id';

/**
 * Correlates every log line of a cloud test run - docs/testing/cloud-integration-testing.md
 * section 8.2. The API echoes it and logs it; it never reaches the database.
 */
export const TEST_RUN_ID_HEADER = 'x-test-run-id';

/** Set by the API if the caller did not supply one, and always echoed. */
export const REQUEST_ID_HEADER = 'x-request-id';
